module.exports = __webpack_public_path__ + "static/media/cp9.7604fbd0.png";